import AjaxForm from "./ajax-form"

export default class extends AjaxForm {
  /**
   * @var HTMLInputElement[]
   */
  protected agreeCheckboxs: HTMLInputElement[] = []

  /**
   * @constructor
   */
  public constructor() {
    super("form-inquiry", "send-inquiry")
    this.init()
  }

  /**
   * @return {void}
   */
  protected init(): void {
    if (this.form) {
      const checkbox: HTMLInputElement | null = this.form.querySelector(
        'input[name="agree"]'
      )
      if (checkbox) {
        this.agreeCheckboxs.push(checkbox)
      }
      this.disagreePrivacyPolicy()
      this.agreePrivacyPolicy()
    }
  }

  /**
   * 同意イベント
   * @returns {void}
   */
  protected agreePrivacyPolicy(): void {
    document
      .querySelectorAll('[data-agree-form="' + this.form.id + '"]')
      .forEach((element: HTMLElement) => {
        element.addEventListener("click", () => {
          this.switchAgree()
        })
      })
  }

  /**
   * 非同意イベント
   * @returns {void}
   */
  protected disagreePrivacyPolicy(): void {
    const modal: HTMLElement = document.getElementById("privacy-policy-modal")
    if (modal) {
      modal.addEventListener("show.bs.modal", () => {
        this.switchAgree(false)
      })
    }
  }

  /**
   * 同意チェックボックスの切り替え
   * @param boolean checked = true
   * @returns {void}
   */
  protected switchAgree(checked: boolean = true): void {
    this.agreeCheckboxs.forEach((checkbox: HTMLInputElement) => {
      checkbox.checked = checked
    })
  }
}
